export var PreviewOrderStatus;
(function (PreviewOrderStatus) {
    // API errors or responses containing an "errorReason" either without an error code or with non-fixable codes.
    PreviewOrderStatus[PreviewOrderStatus["UNFIXABLE_ERROR"] = 0] = "UNFIXABLE_ERROR";
    // API response containing an "errorReason" with a "fixable" error code.
    // An error is fixable if it's related to invalid payment method or delivery address.
    PreviewOrderStatus[PreviewOrderStatus["FIXABLE_ERROR"] = 1] = "FIXABLE_ERROR";
    PreviewOrderStatus[PreviewOrderStatus["SUCCESS"] = 2] = "SUCCESS";
})(PreviewOrderStatus || (PreviewOrderStatus = {}));
export var PreviewOrderErrorType;
(function (PreviewOrderErrorType) {
    PreviewOrderErrorType[PreviewOrderErrorType["PAYMENT_METHOD"] = 0] = "PAYMENT_METHOD";
    PreviewOrderErrorType[PreviewOrderErrorType["DELVERY_ADDRESS"] = 1] = "DELVERY_ADDRESS";
    PreviewOrderErrorType[PreviewOrderErrorType["UNKNOWN"] = 2] = "UNKNOWN";
})(PreviewOrderErrorType || (PreviewOrderErrorType = {}));
export const PaymentMethodErrorMessage = {
    DEFAULT_PAYMENT_METHOD_NOT_SET: { translationKey: 'defaultPaymentMethodNotSet', containsExternalLink: false },
    EXPIRED_DEFAULT_PAYMENT_INSTRUMENT: { translationKey: 'expiredDefaultPaymentInstrument', containsExternalLink: true },
    BILLING_ADDRESS_NOT_SET: { translationKey: 'billingAddressNotSet', containsExternalLink: true },
    PAYMENT_ADDRESS_MISMATCH: { translationKey: 'paymentAddressMismatch', containsExternalLink: true },
    UNSUPPORTED_PAYMENT_INSTRUMENT: { translationKey: 'unsupportedPaymentInstrument', containsExternalLink: true },
    INVALID_PAYMENT_INSTRUMENT: { translationKey: 'invalidPaymentInstrument', containsExternalLink: true },
};
export const DeliveryAddressErrorMessage = {
    DEFAULT_SHIPPING_ADDRESS_NOT_SET: { translationKey: 'defaultShippingAddressNotSet', containsExternalLink: true },
    CANT_SHIP_TO_ADDRESS: { translationKey: 'cannotShipToAddress', containsExternalLink: true },
};
export const getPreviewOrderErrorType = (errorCode) => {
    if (PaymentMethodErrorMessage[errorCode]) {
        return PreviewOrderErrorType.PAYMENT_METHOD;
    }
    if (DeliveryAddressErrorMessage[errorCode]) {
        return PreviewOrderErrorType.DELVERY_ADDRESS;
    }
    return PreviewOrderErrorType.UNKNOWN;
};
export const isFixablePreviewError = (errorCode) => {
    const previewOrderErrorType = getPreviewOrderErrorType(errorCode);
    return (previewOrderErrorType === PreviewOrderErrorType.PAYMENT_METHOD ||
        previewOrderErrorType === PreviewOrderErrorType.DELVERY_ADDRESS);
};
